<template>
  <div class="flex flex-centered flex-vertical-center" style="height: 100%; max-width: 600px; padding: 0 20px; margin: 0 auto;">
    <div style="text-align: center">
      <h1
        style="font-size: 3rem; margin-bottom: 20px;"
      >Test Error Page</h1>

      <p
        style="font-size: 1.3rem; line-height: 1.4;"
      >This is an amazing page where you can hit the button and send a client error to Sentry</p>


      <p
        style="margin-top: 30px; padding: 0 10%; font-size: 1rem; font-weight: bold; line-height: 1.4;"
      >Sentry Error Message</p>

      <input
        type="text"
        v-model="errorMessage"
        style="display: block; margin: 10px auto 0; padding: 6px;"
      >

      <p
        v-if="errorSent"
        style="margin-top: 20px; font-size: 1rem; color: red;"
      >The error has been sent (maybe)</p>

      <button
        @click="throwError"
        style="display: block; background-color: red; margin: 20px auto 10px; padding: 8px 20px; font-size: 2rem; color: white; border-radius: 8px;"
      >Click Here
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestErrorPage",
  data() {
    return {
      errorSent: false,
      errorMessage: "Sentry Error"
    };
  },
  methods: {
    throwError() {
      this.errorSent = true
      throw new Error(this.errorMessage);
    }
  }
};
</script>
